<h1 mat-dialog-title i18n="@@InstructionDialog.title">Instructions</h1>
<div mat-dialog-content>
  <div class="instructions-container">
    <div *ngIf="data.instructions.length === 0" i18n="@@InstructionDialog.noInstructions">No instructions available.</div>
    <div *ngFor="let instruction of data.instructions" class="instruction-item">
      <p><strong i18n="@@InstructionDialog.remarksLabel">Remarks:</strong> {{ instruction.remarks }}</p>
      <div class="image-container">
        <img *ngIf="instruction.image" [src]="instruction.image" alt="Instruction Image" />
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onClose()" appAutofocus i18n="@@InstructionDialog.closeButton"
    class="touch-friendly-button">
    Ok
  </button>
</div>